// extracted by mini-css-extract-plugin
module.exports = {"input-price":"GuessPrice_input-price__Ddobq","animated":"GuessPrice_animated__5TLoT","beat":"GuessPrice_beat__iH2d3"};